export default "__VITE_ASSET__Bj2GR$UR__"